import {
  SelectorListItem,
  TableListItemProps,
  TableListItemColumn,
} from '@wix/design-system';
import { ReactNode } from 'react';

export interface PickerListItemProps
  extends Partial<Omit<TableListItemProps, 'options'>>,
    SelectorListItem {
  options: (Omit<TableListItemColumn, 'value'> & {
    value?: ReactNode;
    end?: boolean;
  })[];
}
